import axios from 'axios';
import {IProductItemCreate} from "@/shared/model/product-item-create.model";
import {ProductCategory} from "@/shared/model/enumerations/product-category.model";

const baseApiUrl = 'api/admin/product';
const basePublicUrl = 'api/public/product';

export default class ProductsService {
    public retrieve(page: number, itemPerPage: number): Promise<any> {
        let url = basePublicUrl;

        const params = new URLSearchParams();

        if (page != null) {
            params.append('page', page.toString());
        }
        if (itemPerPage) {
            params.append('size', itemPerPage.toString());
        }
        const queryString = params.toString();
        if (queryString) {
            url += '?' + queryString;
        }
        return new Promise<any>((resolve, reject) => {
            axios
                .get(url)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public delete(id: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .delete(`${baseApiUrl}/${id}`)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public create(entity: IProductItemCreate, selectedCategory: ProductCategory): Promise<IProductItemCreate> {
        return new Promise<IProductItemCreate>((resolve, reject) => {
            axios
                .post(`${baseApiUrl}?category=${selectedCategory}`, entity)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public update(entity: IProductItemCreate): Promise<IProductItemCreate> {
        return new Promise<IProductItemCreate>((resolve, reject) => {
            axios
                .put(`${baseApiUrl}/${entity.publicId}`, entity)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public find(pId: string): Promise<IProductItemCreate> {
        return new Promise<IProductItemCreate>((resolve, reject) => {
            axios
                .get(`${baseApiUrl}/${pId}`)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
